const appointmentDataContent = {
  title: 'Tu cita incluye',
  first: 'Revisión dental general por un dentista',
  second: 'Escaneo de tus dientes en 3D',
  third: 'Diagnóstico de tratamiento moons'
}

export default appointmentDataContent
